export default __webpack_public_path__ + "static/media/SC.98b9e5f5.svg";